import React, { useEffect, useState } from "react";
import axios from "axios";
import Coin from "./Coin.js";
import "./App.css";

function App() {
  // useState
  const [coins, setdata] = useState([]);
  const [search, setsearch] = useState("");

  // useEffect
  useEffect(() => {
    axios
      .get(
        "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=100&page=1&sparkline=false"
      )
      .then((res) => {
        setdata(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const searchHandler = (e) => {
    setsearch(e.target.value);
  };

  const filterCoins = coins.filter((coin) =>
    coin.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="coin-app">
      <div className="coin-search">
        <h1 className="coin-text">Search a Currency</h1>
        <form>
          <input
            className="search-text"
            onChange={searchHandler}
            type="text"
            placeholder="Search"
            className="coin-input"
          ></input>
        </form>
        {filterCoins.map((coin) => {
          return (
            <Coin
              key={coin.id}
              name={coin.name}
              price={coin.current_price}
              symbol={coin.symbol}
              marketcap={coin.total_volume}
              volume={coin.market_cap}
              image={coin.image}
              priceChange={coin.price_change_percentage_24h}
            ></Coin>
          );
        })}
      </div>
    </div>
  );
}

export default App;
